<template>
<div>
    <div class="pgemnt-1">
        <div class="tbs">
            <el-table :data="showArr" @selection-change="handleSelectionChange" v-loading="false" style="width: 100%" border>
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="标题" prop="title"> </el-table-column>
                <el-table-column label="栏目" prop="columnName" width="145">
                </el-table-column>
                <el-table-column label="浏览量" prop="views" width="145">
                </el-table-column>
                <el-table-column label="发布者" prop="editor" width="90">
                </el-table-column>
                <el-table-column label="发布时间" prop="publishTime" width="160">
                    <template> </template>
                </el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        {{ scope.row.status | filterStatus() }}
                    </template>
                </el-table-column>
                <el-table-column align="left" width="240" label="操作">
                    <template slot-scope="scope">
                        <el-button type="warning" @click="goExamine(scope.row)" size="mini">审核</el-button>
                        <el-button type="danger" @click="delArticle(scope.row.id)" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="params.basePage.no" :page-size="params.basePage.size" layout="total, prev, pager, next" :total="totalElements" :background="false" :hide-on-single-page="true">
                </el-pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    updateProperty,
    getArticleListByCondition,
    delArticle
} from '@/api/jingshi';
export default {
    components: {},
    data() {
        return {
            loading: false,
            ids: [],
            totalElements: 0, //总条数
            showArr: [],
            params: {
                dto: {
                    columnId: '', // 栏目ID
                    type:1,
                    keyword: '', // 关键词
                    status: '2,3', // 1草稿、2待审核、3上线、4退回
                    property: '', // 1推荐属性、2热门属性、3推荐属性
                    class_type: "ArticleListCondition",
                },
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            }
        }
    },
    filters: {
        filterStatus: function (e) {
            var transMap = {
                1: '草稿',
                2: '待审核',
                3: '上线',
                4: '退回'
            };
            return transMap[e];
        }
    },
    methods: {
        search(params) {
            console.log(params);
            if (params) {
                for (let key in params) {
                    if (this.params.dto.hasOwnProperty(key)) {
                        this.params.dto[key] = params[key];
                    }
                }
            }
            this.getList();
        },
        // 获取文章列表
        getList() {
            var vues = this;
            this.loading = true;
            getArticleListByCondition(this.params).then(res => {
                this.showArr = res.articleLists;
                this.totalElements = res.totalElements;
                vues.loading = false;
            })
        },
        // 删除文章列表
        delArticle(id) {
            var param = {
                ids: [id]
            }
            delArticle(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        updateProperty(params){
            var param = {
                ids: params.ids,
                hotProperty:params.hotProperty,
                recommendProperty:params.recommendProperty,
                topProperty:params.topProperty,
            }
            updateProperty(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        // 编辑 
        goExamine: function (e) { // 编辑
            var querys = {};
            querys.id = e.id;
            this.$router.push({
                path: 'inspect_article',
                query: querys
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.params.basePage.no = val;
            this.getList();
        },
        handleSelectionChange(e) {
            console.log(e);
            this.ids = [];
            for (var i = 0; i < e.length; i++) {
                this.ids.push(e[i].id);
            }
        },
        ids() {
            return this.ids;
        },
    },
    created: function () {
        this.getList()
    }
}
</script>

<style lang="scss">
.pgemnt-1 {
    padding: 20px;
}

.pgemnt-1-dag table {
    width: 100%;
    margin-top: 12px;
}

.pgemnt-1 .newAdd {
    width: 90px;
}

// 头部样式
.tbs th {
    background-color: #efefef;
}
.tbs {
  
    .pagination {
      background: white;
        text-align: center;
        margin: 0 0px 0 0px;
    }
}
// .el-input__suffix {
//   right: 0px;
//   transition: all 0.3s;
// }
</style>



// WEBPACK FOOTER //
// list.vue?6c5f612f